import { IconWrap, MessagesBubbleSquareTextIcon, SimpleCard } from '@libs/ui/ds'
import React from 'react'
import type { FC } from 'react'

type Props = {
  note: string
}

export const Note: FC<Props> = ({ note }) => (
  <SimpleCard size='s' data-testid='simple-card-note'>
    <span>
      <IconWrap
        icon={<MessagesBubbleSquareTextIcon />}
        size='s'
        className='mr-0.5'
      />
      {note}
    </span>
  </SimpleCard>
)
